import { useState } from "react";
import { Menu as UIMenu } from '@headlessui/react';
import { faCaretDown, faChevronRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface IMenuItem<T extends IMenuItem<T>>
{
    // id: string;
    text: string;
    icon?: IconDefinition;
    selectable: boolean;
    hasChildren: boolean;
    loadChildren?: () => Promise<T[]>;
    // onClick?: (editor: import('lexical').LexicalEditor) => void;
}

export type MenuItemProperties<T extends IMenuItem<T>> =
{
    item: T
    root?: boolean
    onClick: (item: T) => void
}

export default function Menu<T extends IMenuItem<T>>({ item, root, onClick }: MenuItemProperties<T>)
{
    const [items, setItems] = useState<T[] | null>(null);
    const [expanded, setExpanded] = useState(false);

    const open = async () =>
    {
        if (item.loadChildren && !items)
        {
            const result = await item.loadChildren();
            setItems(result);
            setExpanded(true);
        }
    };

    const handleHover = () =>
    {
        if (item.hasChildren)
        {
            setExpanded(true);
            open();
        }
    };

    const handleLeave = () =>
    {
        setExpanded(false);
    };

    const children = items ? items && items.map((child, i) => <Menu key={i} item={child} onClick={onClick} />) : <div>Loading...</div>;

    if (root)
    {
        const element =
        <UIMenu as="div" className="menu">
            <UIMenu.Button type="button" className="btn" onClick={open}>
                {item.icon && <FontAwesomeIcon icon={item.icon} />}
                {item.text}
                {item.hasChildren && <FontAwesomeIcon icon={faCaretDown} className="caret" />}
            </UIMenu.Button>
            <UIMenu.Items as="ul" className="menu-content" style={{ overflow: 'visible' }}>
                {children}
            </UIMenu.Items>
        </UIMenu>;
        return element;
    }
    else
    {
        const css = item.selectable ? 'menu selectable' : 'menu';
        const element =
        <li className={css} onMouseEnter={handleHover} onMouseLeave={handleLeave} onClick={() => onClick(item)}>
            <span className="menu">
                {item.icon && <FontAwesomeIcon icon={item.icon} />}
                {item.text}
            </span>
            {item.hasChildren && <FontAwesomeIcon icon={faChevronRight} className="submenu-icon" />}
            {expanded &&
                <ul className="menu-content submenu-content">
                    {children}
                </ul>
            }
        </li>;
        return element;
    }
}